import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import swal from 'sweetalert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';

const EditConferenceCategory = (props) => {
    const id = props.match.params.id;
    const history = useHistory();
    const [disabled, setdisabled] = useState(false);
    const [isChecked, setChecked] = useState(false);
    const [isCheckedAttechemt, setCheckedAttechemt] = useState(false);
    const eventName = localStorage.getItem('eventname');
    const eventid = localStorage.getItem('eventid')
    const [dyamicField, setDynamicField] = useState([{ c_field_name: "", c_category_price: "" }]);
  
    const [editConferenceCategories, setEidtConferenceCategory] = useState({
        event_name: eventName,
        conference_category_title: "",
        conference_category_description: "",
        conference_category_coupon:"",
        dynamic_values:[],
        error_list: [],
    
    });  
    const handleCheckboxChange = () => {
        setChecked(!isChecked);
    };
    const handleCheckboxChangeForAttechement = () => {
        setCheckedAttechemt(!isCheckedAttechemt);
    };
    const handleInput = (e) => {
        e.persist();
        setEidtConferenceCategory({ ...editConferenceCategories, [e.target.name]: e.target.value });
    }

    const handleDynamicInput = (e, index) => {
        const { name, value } = e.target;
        const dyamicFieldValue = [...dyamicField];
        dyamicFieldValue[index][name] = value;
        setDynamicField(dyamicFieldValue);
    }
    const handleRemoveDynamicField = index => {
        const dyamicFieldValue = [...dyamicField];
        dyamicFieldValue.splice(index, 1);
        setDynamicField(dyamicFieldValue);

    }

    const handleAddDynamicField = () => {

        setDynamicField([...dyamicField, { c_field_name: "", c_category_price: "" }]);
    }
    useEffect(() => {
      axios.get(`api/conference-category-eidt/${id}`).then((res)=>{
        if(res.status == 200){
           const wcsd = res.data.editConferenceCategory;
           setEidtConferenceCategory(wcsd);
            setChecked(wcsd.conference_category_coupon === 1);
            setCheckedAttechemt(wcsd.conference_category_attechement === 1);

            setDynamicField(wcsd.conference_dynamic_values.map((value) => ({
                c_field_name: value.field_name,
                c_category_price: value.category_price,
              })));
        }
      })
    }, [id]);

   

    const updateWorkshopCategory = (e) => {

        e.preventDefault();

        const data = {
            eventid,
            event_name: editConferenceCategories.event_name,
            conference_category_name: editConferenceCategories.conference_category_title,
            conference_category_descriptions: editConferenceCategories.conference_category_description,
            dyamicField,
            isChecked,
            isCheckedAttechemt,

        }
 console.log("data", data);
        
        // data.event_name == "" ? setdisabled(false) :
        //     data.w_category_name == "" ? setdisabled(false) :
        //         setdisabled(true)

        axios.get('/sanctum/csrf-cookie').then(response => {

            axios.post(`/api/conference-category-update/${id}`, data).then(res => {

                if (res.data.status === 200) {


                    swal('Success', res.data.message, 'success');

                    history.push('/admin/conference/category');
                }
                else {

                    //setAddWorkShopCategory({ ...addWorkShopCategory, error_list: res.data.validate_error })

                }

            });


        });


    }
    let backGroundButtonByEvent = "";
    const [abstractHomeSetup, setAbstractHomeSetup] = useState({
        color_code: "",
        color_code_two: "",
        color_code_three: "",
        call_emergency: "",
        send_email: "",
        event_place: "",
        facebook_link: "",
        Instagram_link: "",
        linkedin_link: "",
        twitter_link: "",
        abstractFooterImage: "",
        abstractBannerImage: "",
        abstractSponserLogos: "",
        error_list: [],
    });
    React.useEffect(() => {
        axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
            if (res.status === 200) {
                const getHomePageData = res.data.HomePageSetup;
                setAbstractHomeSetup(getHomePageData);
            }
        })

    }, [eventid]);

    if (eventid) {
        backGroundButtonByEvent = `${abstractHomeSetup.color_code_two}`; // Assign the value conditionally
    }
    else {
        backGroundButtonByEvent = '#145348'; // Default background color
    }
    //backgroundColor: backGroundButtonByEvent,
    return (

        <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
            <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>
                <h4 sx={{ m: 2, color: '#000000' }} >
                    <Button sx={{
                        float: 'right',
                        marginTop: '2%',
                        backgroundColor: backGroundButtonByEvent,
                        ":hover": {
                            color: "white"
                        }
                    }}
                        color='success'
                        size='small'
                        variant='contained'
                        onClick={() => history.goBack()}>
                        Back
                    </Button>
                </h4>
                <Card sx={{ width: '60vw', float: 'center' }} >
                    <CardContent >
                        <Typography component="h1" variant="h5">
                            Eidt Conferecnce Category
                        </Typography>
                        <Box component="form" onSubmit={updateWorkshopCategory} noValidate sx={{ mt: 3 }}>
                            <Grid container spacing={4}>
                                <Grid item xs={6} >
                                    <TextField
                                        disabled
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Evnet Name"
                                        autoFocus
                                        name='event_name' onChange={handleInput}
                                        defaultValue={eventName || ""}
                                         />
                                </Grid>

                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Category Name"
                                        autoFocus
                                        value={editConferenceCategories.conference_category_title || ""}
                                        name='conference_category_title' onChange={handleInput}
                                        //helperText={editWorkShopCategory.error_list.workshop_category_name} 
                                        />
                                </Grid>

                                <Grid item xs={12} >

                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth

                                        label="Add Descriptions"
                                        autoFocus
                                        name='conference_category_description' onChange={handleInput}
                                        multiline
                                        rows={6}
                                        value={editConferenceCategories.conference_category_description || ""}
                                        //helperText={addWorkShopCategory.error_list.workshop_category_descriptions}
                                         />

                                </Grid>
                                <Grid item xs={6} >
                                    <FormControlLabel required control={<Checkbox color="success" />}
                                        label=" Coupon"
                                        color="success"
                                        onChange={handleCheckboxChange} 
                                        checked={isChecked}
                                         />
                                    <FormHelperText>Coupon is {isChecked ? ' Applied' : ' Not Applied'}.</FormHelperText>
                                </Grid>

                                <Grid item xs={6} >
                                    <FormControlLabel required control={<Checkbox color="success" />}
                                        label="Attachment"
                                        color="success"
                                        onChange={handleCheckboxChangeForAttechement} value="41" checked={isCheckedAttechemt} />
                                    <FormHelperText>Attachment is {isCheckedAttechemt ? 'Required' : ' Not Required'}.</FormHelperText>
                                </Grid>
                                
                                {
                                    dyamicField && dyamicField.map((val, i) => {
                                        return (

                                            <React.Fragment key={i + 1}>
                                                <Grid item xs={4} >
                                                    <TextField
                                                        autoComplete="given-name"
                                                        required
                                                        fullWidth
                                                        label="Field name"
                                                       
                                                        name='c_field_name' onChange={e => handleDynamicInput(e, i)}
                                                        value={val.c_field_name} />
                                                </Grid>
                                                <Grid item xs={4} >
                                                    <TextField
                                                        autoComplete="given-name"
                                                        required
                                                        fullWidth
                                                        label="Price"
                                                        
                                                        name='c_category_price' onChange={e => handleDynamicInput(e, i)}
                                                        value={val.c_category_price}/>
                                                </Grid>

                                                <Grid item xs={4} >

                                                    {
                                                        dyamicField.length !== 1 &&
                                                        <Button
                                                            onClick={() => handleRemoveDynamicField(i)}
                                                            variant="contained"
                                                            sx={{ mt: 1, backgroundColor: '#5a020b', }} >
                                                            Remove
                                                        </Button>
                                                    }
                                                    {
                                                        dyamicField.length - 1 === i &&
                                                        <Button
                                                            onClick={handleAddDynamicField}
                                                            variant="contained"
                                                            sx={{ m: 1, backgroundColor: backGroundButtonByEvent, }} >
                                                            Add New Row
                                                        </Button>
                                                    }
                                                </Grid>
                                            </React.Fragment>

                                        );
                                    })
                                }




                            </Grid>

                            <Grid container justifyContent="flex-end">
                                <Button
                                    disabled={disabled}
                                    type="submit"
                                    // fullWidth
                                    variant="contained"
                                    sx={{ mt: 5, backgroundColor: backGroundButtonByEvent, }} >
                                    Add WorkShop Category
                                </Button>
                            </Grid>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </div>

    );
}
export default EditConferenceCategory;
